import { render, staticRenderFns } from "./FactoryListNew.vue?vue&type=template&id=79ecd134"
import script from "./FactoryListNew.vue?vue&type=script&lang=js"
export * from "./FactoryListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports